const mEditionAssetContentsTreeNodeActions = {
  mEditionAssetContentsTreeNodeActions: {
    actions: {
      visto: 'visto'
    }
  }
}
export default mEditionAssetContentsTreeNodeActions
